<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data PIC" subTitle="Forms" />

    <ListPic />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListPic from "@/components/Pages/Data/Pic/ListPic.vue";

export default defineComponent({
  name: "ListPicPage",
  components: {
    PageTitle,
    ListPic,
  },
});
</script>
